import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import hidePwdImg from '../../asset/new/icons/hide_passwd_icon.svg';
import showPwdImg from '../../asset/new/icons/show_passwd.svg';
import {
  googleRegisterRequest,
  registerUser,
} from "../../Redux/Slices/AuthSlice";
import { useGoogleLogin } from "@react-oauth/google";
import Icongoogle from "../../asset/new/icons/icongoogle.svg";

const intialvalue = {
  name: "",
  email: "",
  mobile: "",
  password: "",
  role_id: "Jobseeker",
  experience_level: "",
};

const SignUp = () => {
  const [user, setUser] = useState(intialvalue);
  const [error, setError] = useState({});
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { redirectReg } = useSelector((state) => state?.Auth);

  // Google login Hook
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const profile = await res.json();
        responseGoogle(profile);
      } catch (err) {
        console.error("Google login fetch error:", err);
      }
    },
    onError: () => console.log("Login Failed"),
  });

  // Form Validation
  const validation = () => {
    let error = {};
    if (!user.name) error.name = "@Name is Required";
    if (!user.email) {
      error.email = "@Email is Required";
    } else if (
      !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(user.email)
    ) {
      error.email = "@Enter a Valid Email";
    }
    if (!user.password) error.password = "@Password is Required";
    if (!user.mobile) error.mobile = "@Mobile is Required";
    return error;
  };

  const postUserData = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    setError({ ...error, [name]: "" });
  };

  // Submit Button
  const SubmitInfo = async (e) => {
    e.preventDefault();
    let ErrorList = validation();
    setError(ErrorList);

    if (Object.keys(ErrorList).length === 0) {
      let data = {
        name: user.name,
        email: user.email,
        password: user.password,
        mobile: user.mobile,
        role_id: "Jobseeker",
        experience_level: user.experience_level,
      };
      dispatch(registerUser(data));
    }
  };

  //  Google Authentication
  const responseGoogle = async (profile) => {
    let data = {
      name: profile?.name,
      email: profile?.email,
      google_id: profile?.sub,
      role_id: "Jobseeker",
    };
    dispatch(googleRegisterRequest(data));
  };

  useEffect(() => {
    document.title = "SignUp | CAJobPortal";
  }, []);

  return (
    <section className="auth-shell">
      <div className="auth-container">
        <div className="auth-card auth-card-signup">
          <div className="auth-header text-center">
            <h3 className="auth-title">Create Jobseeker Account</h3>
            <p className="auth-subtitle">Build your profile and apply to the best opportunities faster.</p>
          </div>

          <form className="auth-form">
            <div className="auth-switch-text">
              Already have an account?
              <Link to={"/signin"} className="auth-inline-link">
                {" "}Sign in Here{" "}
              </Link>
            </div>
            <div className="auth-switch-text mb-3">
              Register as
              <Link to={"/signup-recruiter"} className="auth-inline-link">
                {" "}Recruiter{" "}
              </Link>
            </div>

            <div className="form-floating mb-3 auth-field">
              <input name="name" onChange={postUserData} type="text" className="form-control" placeholder="Your Name" />
              <label>Name</label>
              <span className="auth-error-text">{error.name}</span>
            </div>

            <div className="form-floating mb-3 auth-field">
              <input name="email" onChange={postUserData} type="email" className="form-control" placeholder="name@example.com" />
              <label>Email address</label>
              <span className="auth-error-text">{error.email}</span>
            </div>

            <div className="form-floating mb-3 auth-field">
              <input name="mobile" onChange={postUserData} type="text" className="form-control" placeholder="Enter Mobile Number" />
              <label>Mobile Number*</label>
              <span className="auth-error-text">{error.mobile}</span>
            </div>

            <div className="form-floating pwd-container mb-3 auth-field">
              <input
                name="password"
                onChange={postUserData}
                type={isRevealPwd ? "text" : "password"}
                className="form-control"
                placeholder="Password"
              />
              <img
                title={isRevealPwd ? "Hide password" : "Show password"}
                alt="passwd_img"
                src={isRevealPwd ? hidePwdImg : showPwdImg}
                onClick={() => setIsRevealPwd(prev => !prev)}
              />
              <label>Password</label>
              <span className="auth-error-text">{error.password}</span>
            </div>

            <select
              className="form-select mb-3 auth-select"
              onChange={postUserData}
              name="experience_level"
            >
              <option>Experience Level</option>
              <option value={"Fresher"}>Fresher</option>
              <option value={"Experienced"}>Experienced</option>
            </select>

            <button
              onClick={SubmitInfo}
              type="submit"
              className="btn auth-submit-btn w-100 mt-2"
            >
              Sign Up
            </button>

            <div className="auth-separator">or</div>

            {/* Google Sign Up */}
            <button
              onClick={googleLogin}
              type="button"
              className="btn auth-google-btn w-100 d-flex align-items-center justify-content-center"
            >
              <img src={Icongoogle} alt="Google logo" className="auth-google-icon" />
              Sign Up with Google
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
